import React from 'react';
import { useGroupTabContext } from './context';
import { StyledSearch, StylesGroupTabWrapper } from './styles';
import Input from '../../../../../../libs/uiKit/input';
import { SearchIcon } from '../../../../../../icons/ui/Search';
import Loader from '../../../../../../libs/uiKit/loader';
import { Heading3, Text4 } from '../../../../../../libs/uiKit/globalStyledComponents';
import GroupToggle from './GroupToggle';
import GroupUserItem from './GroupUser';

const GroupTabUi: React.FC = () => {
	const { isLoading, searchHandler, isHaveFilters, filterGroups, filterUsers, searchWord } = useGroupTabContext();

	return (
		<StylesGroupTabWrapper>
			<StyledSearch>
				<Input placeholder='Поиск по названию группы' debounceMs={500} onChange={searchHandler} iconAfter={<SearchIcon />} />
			</StyledSearch>
			{isLoading && <Loader />}
			{!isLoading && isHaveFilters && <Heading3>Найдено групп</Heading3>}
			{!isLoading && !!filterGroups.length && filterGroups.map(group => <GroupToggle key={group.id} group={group} isFiltered={isHaveFilters} searchWord={searchWord} />)}
			{!isLoading && !filterGroups.length && isHaveFilters && <Text4>Групп не найдено</Text4>}
			{!isLoading && isHaveFilters && !!filterUsers.length && <Heading3>Пользователи без группы</Heading3>}
			{!isLoading && !!filterUsers.length && isHaveFilters && filterUsers.map(user => <GroupUserItem {...user} searchWord={searchWord} />)}
		</StylesGroupTabWrapper>
	);
};

export default React.memo(GroupTabUi);
